/**
 * DatenbankTab — Configuration AP "database" tab.
 *
 * Three rendering cases driven by DB + session state:
 *   1. configured (with or without an active diff session) → full
 *      ScopeTabs + SelectionBadge + PivotTable. When actionState.diffs
 *      is populated (seeded by seedImportDiff on upload), PivotTable
 *      + DiffCell + DiffToolbar render the diff overlay and drive
 *      progress calculations natively — no extra banner needed.
 *   2. empty DB, diff active on fresh upload → transient message;
 *      the refresh after open_session will flip dbConfigured to true
 *      and this branch gives way to case 1.
 *   3. empty DB, no diff → inert placeholder.
 *
 * Anwenden lives on the Aktionen tab (the single commit path — §7.5).
 */

import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useStore } from "../../../store/useStore"
import { ScopeTabs } from "../../layout/ScopeTabs"
import { SelectionBadge } from "../../layout/SelectionBadge"
import { PivotTable } from "../../pivot/PivotTable"

export function DatenbankTab() {
  const { translate } = useTranslation()
  const { dbConfigured, activeScopeId, activeDiffSessionId } = useStore()

  if (dbConfigured) {
    return (
      <div className="flex h-full flex-col overflow-hidden">
        <ScopeTabs />
        <SelectionBadge />
        <div className="flex-1 overflow-hidden">
          <PivotTable key={activeScopeId} scopeId={activeScopeId} />
        </div>
      </div>
    )
  }

  if (activeDiffSessionId) {
    return (
      <div className="flex h-full items-center justify-center bg-grey2">
        <p className="max-w-md px-6 text-center text-sm text-grey5">
          {translate("QMS/DATABASE/PREPARING")}
        </p>
      </div>
    )
  }

  return (
    <div className="flex h-full items-center justify-center bg-grey2">
      <p className="max-w-md px-6 text-center text-sm text-grey5">
        {translate("QMS/DATABASE/EMPTY_UPLOAD")}
      </p>
    </div>
  )
}
